import styled from "styled-components";

export const Container = styled.div`
  background-color: #ffffff;
  width: 100%;
  height: 100vh;
  padding: 20px;
  overflow-x: hidden;
`;

export const BoxDesktop = styled.div`
  display: flex;
  justify-content: flex-start;
  max-width: 620px;
  margin: 1rem auto;
  flex-direction: column;

  @media(max-width: 770px) {
    display: none;
  }
`;

export const BoxMobile = styled.div`
  @media(max-width: 770px) {
    display: flex;
    flex-direction: column;
  }

  @media(min-width: 770px) {
    display: none;
  }
`;

export const CardContainer = styled.div`
  background-color: #ffffff;
  width: 100%;
  height: 100vh;
  padding: 20px 20px 0px 20px;
  overflow-x: hidden;
  margin-bottom: -5rem;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Left = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;

  img {
    margin: 0 .5rem 0 0;
  }
`;

export const Title = styled.span`
  font-size: 23px;
  color: #ffffff;
`;

export const Icon = styled.span`
  font-size: 35px;
  color: #ffffff;
`;

export const CloseIcon = styled.span`
  font-size: 27px;
  margin-right: 20px;
  color: #ffffff;
  cursor: pointer;
`;

export const Content = styled.div`
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding: 20px;
  border-radius: 22px;

  @media(max-width: 770px) {
    padding: 5px 20px 20px 20px;
  }

  @media(max-width: 370px) {
    padding: 5px 10px 20px 10px;
  }
`;

export const CardTitle = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: #487cf5;
`;

export const List = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 1rem 0 0 0;

  @media(max-width: 770px) {
    grid-template-columns: 1fr;
  }
`;

export const Item = styled.li`
  list-style-type: none;
  margin: .5rem 0;
  color: #338bfb;
  padding: 0 .5rem 0 0;

  span {
    color: #707070;
  }

  @media(max-width: 770px) {
    display: flex;
    flex-direction: column;
  }
`;

export const ContentStatus = styled.div`
  display: flex;
  align-items: center;
  color: #707070;
  font-size: 11px;
`;

export const StatusCollor = styled.div`
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 2rem;
  margin: 0rem 0.3rem 0 0;
  background-color: ${(props) => {
    if (
      props.status === "PENDING_ANALYSIS"
    ) {
      return `#606060`
    } else if(props.status === "APPROVED") {
      return `#00E309`
    } else if(props.status === "PENDING_APPROVAL") {
      return `#606060`
    } else {
      return `#FD0000`;
    }
  }};
`;

export const DivisionTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;